import Map from 'app/components/map/Map'
import {_} from 'i18n'
import React from 'react'
import {Button} from 'react-bootstrap'
import {useHistory} from 'react-router-dom'

import {ContainerHeader, DetailContainer, Paper} from '../styles'

const ProposaLocation = ({coordinates, city, newCoordinates}) => {
  const history = useHistory()
  return (
    <Paper id="location">
      <ContainerHeader>
        {_`Localização da Oportunidade`}
        <Button
          variant="outline-primary"
          onClick={() => history.push(`/cities/${city.id}`)}
          style={{color: '#1E7BE1', borderColor: '#1E7BE1'}}>
          {_`VER CIDADE`}
        </Button>
      </ContainerHeader>
      <DetailContainer style={{padding: 0}}>
        {coordinates && coordinates.length > 0 && (
          <Map
            customStyle={{
              borderRadius: 0,
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              width: '100%',
              margin: 0,
            }}
            coordinates={newCoordinates}
            zoomIn={16}
            scrollZoomDisable
            noFitBounds
          />
        )}
      </DetailContainer>
    </Paper>
  )
}

export default ProposaLocation
